// extracted by mini-css-extract-plugin
module.exports = {"scrollbarWrapper":"styles_scrollbarWrapper__9WJ9W","scrollbar":"styles_scrollbar__1OcmJ"};